import React, { Component } from 'react';
import posthog from 'posthog-js';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Send to PostHog
        if (posthog) {
            posthog.capture('$exception', {
                $exception_message: error.message,
                $exception_type: error.name || 'React ErrorBoundary',
                $exception_stack_trace_raw: error.stack,
                ...errorInfo
            });
        }
        console.error("Uncaught error caught by ErrorBoundary:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-secondary)' }}>
                    <h2>Something went wrong.</h2>
                    <p>We've tracked this error and will look into it.</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-primary"
                        style={{ marginTop: '1rem' }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
